<template>
  <div class="mx-auto text-sm overflow-hidden relative">
    <div class="relative max-w-8xl mx-auto">
      <button
        type="button"
        class="fixed z-20 top-0 right-0 h-14 w-14 bg-white border rounded-bl-lg md:top-5 md:rounded-tl-lg"
        @click="open"
      >
        <div class="flex h-full flex-col justify-center items-center gap-y-2">
          <svg
            width="28"
            height="2"
            viewBox="0 0 28 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="28"
              y1="1"
              x2="-8.74228e-08"
              y2="0.999998"
              stroke="#212121"
              stroke-width="2"
            />
          </svg>
          <svg
            width="19"
            height="2"
            class="-ml-2"
            viewBox="0 0 19 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="19"
              y1="1"
              y2="1"
              stroke="#212121"
              stroke-width="2"
            />
          </svg>
        </div>
      </button>
      <!--        Skal være hidden med mindre man trykker på meny, når man scroller ned siden skal den komme ut automatisk på destination intro, id for div er destIntro-->
      <div
        id="burgerMenu"
        class="fixed w-48 -right-48 rounded-bl-lg overflow-hidden z-20 bg-white border transition-all duration-500 md:top-5 md:rounded-tl-lg"
      >
        <button
          type="button"
          class="absolute top-2 right-2"
          @click="close"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="14.8905"
              y1="14.5062"
              x2="1.09156"
              y2="0.707189"
              stroke="#666666"
              stroke-width="2"
            />
            <line
              x1="14.5059"
              y1="0.707107"
              x2="0.706944"
              y2="14.5061"
              stroke="#666666"
              stroke-width="2"
            />
          </svg>
        </button>
        <div class="w-full flex flex-col justify-between">
          <div
            v-for="(destination, index) in destinations"
            v-if="destinations.length > 1"
            :key="destination"
            class="w-full h-20 flex-grow border-b last:border-none"
          >
            <a
              :href="`#destIntro-${destination.id}`"
              class="w-full h-full flex items-center justify-between"
              :class="{ 'border-l-2 border-icon font-semibold': destination.isActive === true }"
            >
              <span
                :id="index"
                class="flex text-xl items-center ml-5"
              >
                {{ destination.city }}
                <svg
                  v-if="destination.isActive === true"
                  :class="{ active: index === currentSection.isActive }"
                  width="15"
                  height="17"
                  class="mt-1 ml-2"
                  viewBox="0 0 13 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5076 10.7986C9.93477 11.3714 8.82225 12.4839 7.91455 13.3916C7.1335 14.1727 5.86749 14.1724 5.08644 13.3913C4.19562 12.5005 3.10257 11.4075 2.49371 10.7986C0.280742 8.58563 0.280742 4.9977 2.49371 2.78473C4.70668 0.571757 8.29462 0.571757 10.5076 2.78473C12.7206 4.9977 12.7206 8.58563 10.5076 10.7986Z"
                    stroke="#01798A"
                    stroke-width="1.41667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.62565 6.79167C8.62565 7.96527 7.67426 8.91667 6.50065 8.91667C5.32705 8.91667 4.37565 7.96527 4.37565 6.79167C4.37565 5.61806 5.32705 4.66667 6.50065 4.66667C7.67426 4.66667 8.62565 5.61806 8.62565 6.79167Z"
                    stroke="#01798A"
                    stroke-width="1.41667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </a>
          </div>
          <div
            v-if="destinations.length > 1"
            class="w-full h-20 flex-grow border-b last:border-none"
          >
            <div class="w-full h-full flex items-center justify-between hover:border-l hover:border-success-dark">
              <button
                type="button"
                class="flex text-xl items-center ml-5"
                @click="priceOffer"
              >
                <p class="focus:font-semibold">
                  Pristilbud
                </p>
              </button>
            </div>
          </div>
          <div
            v-if="destinations.length === 1"
            class="w-full py-4"
          >
            <div
              v-for="(destination) in destinations"
              :key="destination"
            >
              <div class="flex text-2xl items-center ml-5 mt-2 mb-4 ">
                <svg
                  width="13"
                  height="15"
                  class="mr-2"
                  viewBox="0 0 13 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5076 10.7986C9.93477 11.3714 8.82225 12.4839 7.91455 13.3916C7.1335 14.1727 5.86749 14.1724 5.08644 13.3913C4.19562 12.5005 3.10257 11.4075 2.49371 10.7986C0.280742 8.58563 0.280742 4.9977 2.49371 2.78473C4.70668 0.571757 8.29462 0.571757 10.5076 2.78473C12.7206 4.9977 12.7206 8.58563 10.5076 10.7986Z"
                    stroke="#01798A"
                    stroke-width="1.41667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M8.62565 6.79167C8.62565 7.96527 7.67426 8.91667 6.50065 8.91667C5.32705 8.91667 4.37565 7.96527 4.37565 6.79167C4.37565 5.61806 5.32705 4.66667 6.50065 4.66667C7.67426 4.66667 8.62565 5.61806 8.62565 6.79167Z"
                    stroke="#01798A"
                    stroke-width="1.41667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ destination.city }}
              </div>
            </div>
            <section
              v-for="(block, index) in proposalBlocks"
              :key="block.id"
              class="flex justify-between border-l ml-7 py-2 first:pt-0 last:pb-0"
            >
              <a
                :href="`#blockId-${block.id}`"
                :class="block.isActive ? 'flex font-light ml-3 flex-grow text-success-dark' : 'flex font-light ml-3 flex-grow'"
              >
                <span :id="index">
                  {{ block.section }}
                </span>
              </a>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Hero :project="{
        title: proposal.data.title,
        description: proposal.data.subtitle,
        image: proposal.data.image?.mime_type.includes('image/') ? (typeof proposal.data.image.media_crop === 'object' ? proposal.data.media_crop.url : proposal.data.image.original_url)  : '',
        alt: proposal.data.image?.name,
        logo: '',
        video: proposal.data.image?.mime_type === 'video/mp4' ? proposal.data.image.original_url : ''
      }"/>
      <FeaturedBullets :features="{
        company: proposal.data.client ? proposal.data.client.name : '',
        start_date: proposal.data.start_date,
        end_date: proposal.data.end_date,
        destination: proposal.data.places.length > 0 ? proposal.data.places[0].name : '',
        activities: '',
      }"/>
      <TripIntro :trip="{
        image: proposal.data.teaser_media_crop ? proposal.data.teaser_media_crop.url : proposal.data.teaser_image?.original_url,
        alt: proposal.data.teaser_image?.name,
        title: proposal.data.teaser_title,
        info: proposal.data.teaser_description,
      }"/>
      <TripHighlights
        v-if="highlights.length > 0"
        :id="'blockId-' + proposalBlocks[0].id"
        :highlights="highlights"
        :headline="proposal.data.data.headlines === Array ? proposal.data.data.headlines.highlights : 'Høydepunkter'"
      />
      <template v-for="destination in proposal.data.places">
        <DestinationIntro
          :id="'destIntro-' + destination.id"
          :city="destination.name"
          :country="destination.parent ? destination.parent.name : destination.area"
          :center="{
                    lat: destination.location.coordinates[1],
                    lng: destination.location.coordinates[0]
                }"
          :description="destination.pivot.description"
          :heading="destination.pivot.heading"
        />
        <div :id="'blockId-' + proposalBlocks[1].id">
          <DestinationActivities
            :headlines="proposal.data.data.headlines"
            :destinationId="destination.id"
            :pivotId="destination.pivot.id + '-activities'"
            :activities="proposal.data.itinerary"
          />
        </div>
        <DestinationProgram
          v-if="highlights.length > 0"
          :id="'blockId-' + proposalBlocks[2].id"
          :destinationId="destination.id"
          :highlights="highlights"
        />
        <DestinationAccommodation
          :id="'blockId-' + proposalBlocks[3].id"
          :destinationId="destination.id"
          :headlines="proposal.data.data.headlines"
          :pivotId="destination.pivot.id + '-lodgings'"
          :accomodations="proposal.data.itinerary"
        />
        <DestinationsRestaurants
          :id="'blockId-' + proposalBlocks[4].id"
          :destinationId="destination.id"
          :headlines="proposal.data.data.headlines"
          :pivotId="destination.pivot.id + '-eateries'"
          :eateries="proposal.data.itinerary"
        />
        <DestinationPlan
          v-if="proposal.data.itinerary.length > 0"
          :id="'blockId-' + proposalBlocks[5].id"
          :destinationId="destination.id"
          :headlines="proposal.data.data.headlines"
          :pivotId="destination.pivot.id + '-plan'"
          :itineraries="proposal.data.itinerary"
          :city="destination.name"
          :center="{
                    lat: destination.location.coordinates[1],
                    lng: destination.location.coordinates[0]
                }"
        />
        <DestinationGallery :gallery="proposal.data.gallery"/>
      </template>
      <Program
        v-if="proposal.data.itinerary.length > 0"
        :program="proposal.data.itinerary"
        :title="proposal.data.data.headlines === Array ? proposal.data.data.headlines.program : 'Program'"
      />
      <Flights
        v-if="proposal.data.data.flights.length > 0"
        :id="'blockId-' + proposalBlocks[6].id"
        :flights="proposal.data.data.flights"
        :headline="proposal.data.data.headlines === Array ? proposal.data.data.headlines.flight_times : 'Flytider'"
      />
      <PriceOffer
        v-if="proposal.data.data.optional_additions.length > 0 && proposal.data.data.summary"
        id="priceOffer"
        :prices="proposal.data"
        :headline="proposal.data.data.headlines === Array ? proposal.data.data.headlines.offer : 'Tilbud'"
      />
    </div>
  </div>
</template>

<script setup>

import { computed, onMounted, ref, watch } from 'vue'
import Hero from '../../ComponentsDeprecated/Proposal/Public/Hero.vue'
import FeaturedBullets from '../../ComponentsDeprecated/Proposal/Public/FeaturedBullets.vue'
import TripIntro from '../../ComponentsDeprecated/Proposal/Public/TripIntro.vue'
import TripHighlights from '../../ComponentsDeprecated/Proposal/Public/TripHighlights.vue'
import DestinationIntro from '../../ComponentsDeprecated/Proposal/Public/DestinationIntro.vue'
import DestinationActivities from '../../ComponentsDeprecated/Proposal/Public/DestinationActivities.vue'
import DestinationProgram from '../../ComponentsDeprecated/Proposal/Public/DestinationProgram.vue'
import DestinationAccommodation from '../../ComponentsDeprecated/Proposal/Public/DestinationAccommodation.vue'
import DestinationsRestaurants from '../../ComponentsDeprecated/Proposal/Public/DestinationRestaurants.vue'
import DestinationPlan from '../../ComponentsDeprecated/Proposal/Public/DestinationPlan.vue'
import DestinationGallery from '../../ComponentsDeprecated/Proposal/Public/DestinationGallery.vue'
import Program from '../../ComponentsDeprecated/Proposal/Public/Program.vue'
import Flights from '../../ComponentsDeprecated/Proposal/Public/Flights.vue'
import PriceOffer from '../../ComponentsDeprecated/Proposal/Public/PriceOffer.vue'

const props = defineProps({
  proposal: {
    type: Object,
    required: true,
  }
});

const destinations = ref(props.proposal.data.places.map((o) => {
  return {
    city: o.name ?? '',
    country: o.parent !== null ? o.parent.name : o.area,
    center: { lat: o.location.coordinates[1], lng: o.location.coordinates[0] },
    id: o.id,
    isActive: false
  }
}))

const highlights = computed(() => props.proposal.data.itinerary.filter(activity => activity.highlighted));

const proposalBlocks = ref([
  {
    section: 'Høydepunkter',
    id: 1,
    isActive: false,
  },
  {
    section: 'Aktiviteter',
    id: 2,
    isActive: false,
  },
  {
    section: 'Program',
    id: 3,
    isActive: false,

  },
  {
    section: 'Overnatting',
    id: 4,
    isActive: false,

  },
  {
    section: 'Spisesteder',
    id: 5,
    isActive: false,

  },
  {
    section: 'Planlagt',
    id: 6,
    isActive: false,
  },
  {
    section: 'Flytider',
    id: 7,
    isActive: false,
  },
  {
    section: 'Pristilbud',
    id: 8,
    isActive: false,
  },
]);

const currentSection = ref('');
const currentBlock = ref('');

const destinationTypes = props.proposal.data.itinerary.map(e => {
  return e.type
})

onMounted(() => {
  if (destinations.value.length > 1) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            currentSection.value = entry.target.getAttribute('id');
            document.getElementById('burgerMenu').classList.replace('-right-48', 'right-0');
          } else {
            document.getElementById('burgerMenu').classList.replace('right-0', '-right-48');
          }
        });
      },
      {
        rootMargin: '0px 0px -99% 0px',
      },
    );
    document.querySelectorAll('[id^=\'destIntro\']').forEach((section) => {
      observer.observe(section);
    });
  } else if (destinations.value.length === 1) {
    const blockObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            currentBlock.value = entry.target.getAttribute('id');
          }
        });
      },
      {
        rootMargin: '0px 0px -99% 0px',
      },
    );
    document.querySelectorAll('[id^=\'blockId\']').forEach((section) => {
      blockObserver.observe(section);
    });
  } else {
    console.log('No destinations');
  }
});

watch(currentSection, (cur, prev) => {
  const curArr = cur.split('-');
  const prevArr = prev.split('-');
  destinations.value.find((dest) => {
    dest.isActive = dest.id === parseInt(prevArr[1]);
  });
  destinations.value.find((dest) => {
    dest.isActive = dest.id === parseInt(curArr[1]);
  });
  return currentSection.value = cur;
});

watch(currentBlock, (cur, prev) => {
  const curArr = cur.split('-');
  const prevArr = prev.split('-');
  proposalBlocks.value.find((block) => {
    block.isActive = block.id === parseInt(prevArr[1]);
  });
  proposalBlocks.value.find((block) => {
    block.isActive = block.id === parseInt(curArr[1]);
  });
  return currentBlock.value = cur;
});

function priceOffer() {
  const target = document.getElementById('priceOffer');
  target.scrollIntoView({behavior: 'smooth'});
}

function open() {
  document.getElementById('burgerMenu').classList.replace('-right-48', 'right-0');
}

function close() {
  document.getElementById('burgerMenu').classList.replace('right-0', '-right-48');
}
</script>
<script>
import EmptyLayout from '@/Layouts/EmptyLayout';
export default { layout: EmptyLayout };
</script>
